import { render } from "./Monitoring.vue?vue&type=template&id=0abb96ef"
import script from "./Monitoring.vue?vue&type=script&lang=js"
export * from "./Monitoring.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/views/project/Monitoring.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0abb96ef"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0abb96ef', __exports__)) {
    api.reload('0abb96ef', __exports__)
  }
  
  module.hot.accept("./Monitoring.vue?vue&type=template&id=0abb96ef", () => {
    api.rerender('0abb96ef', render)
  })

}


export default __exports__